import React from 'react'
import MainIcon from '../../../../../img/svg/main'
import { TableTimerText, TableTimerWrapper } from '../index.styled'
import { useSelector } from 'react-redux'
import { selectIsTimerLimitExceeded, selectTimeSinceLastOrder } from '../../../../../redux/selector/timerCounter'

const TableTimer = React.memo(({ table }) => {
	const lastOrderDate = table.lastServiceMeta?.lastOrderDate
	const timer = useSelector(selectTimeSinceLastOrder(lastOrderDate))
	const isTimerLimit = useSelector(selectIsTimerLimitExceeded(lastOrderDate))

	return (
		<TableTimerWrapper className={isTimerLimit ? ' timer-limit' : ''}>
			<MainIcon icon="clock" />
			<TableTimerText>{timer}</TableTimerText>
		</TableTimerWrapper>
	)
})

TableTimer.displayName = 'TableTimer'
export default TableTimer
